import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import AccountDefinition from './account-definition/account-definition';
import TabPanel, { Item } from "devextreme-react/tab-panel";
import AccountRelation from './account-relation/account-relation';
import AccountParameterList from './account-parameter-list/account-parameter-list';
import AccountApplications from './account-application/account-applications';
import AccountEmailList from './account-email/account-email-list';

export function AccountManagement() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const [accountId, setAccountId] = useState(params.id);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleAfterSubmit = (savedAccount: any) => {
        setAccountId(savedAccount.id);
    };
    return (
        <div>
            <AccountDefinition accountId={params.id} onAfterSubmit={handleAfterSubmit}></AccountDefinition>
            {accountId && (
                <div className='card mb-5 mb-xl-10'>
                    <div id='account_definition' className='collapse show'>
                        <div className='card-body border-top p-5'>
                            <TabPanel id="tabs"
                                selectedIndex={selectedIndex}
                                onSelectionChanged={(e: any) => setSelectedIndex(e.component.option("selectedIndex"))}>
                                <Item title={t("applications")}>
                                    <AccountApplications accountId={accountId} ></AccountApplications>
                                </Item>
                                <Item title={t("account_relations")}>
                                    <AccountRelation accountId={accountId} ></AccountRelation>
                                </Item>
                                <Item title={t("parameters")}>
                                    <AccountParameterList accountId={accountId} ></AccountParameterList>
                                </Item>
                                <Item title={t("email_addresses")}>
                                    <AccountEmailList accountId={accountId} ></AccountEmailList>
                                </Item>
                            </TabPanel>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
export default AccountManagement